import React from 'react';
import { eSearchBarColumns } from 'types/globalSearchBar/IGlobalSearchBarSettings';
import { FeesUpdatedAt } from './FeesUpdatedAt';
import { LastVisit } from './LastVisit';
import { prettyInternalOrderStatus } from '../../../ui-toolkit/enums/eInternalOrderStatus';
import { addressDataToString } from '../../../ui-toolkit/orders/interfaces/IAddressResponse';
import {
  getBorrowerStringFromParties,
  ISearchOrderRequest,
} from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

export const defaultColumns = [
  eSearchBarColumns.FileNumber,
  eSearchBarColumns.Address,
  eSearchBarColumns.ClosingDate,
  eSearchBarColumns.LastVisit,
];
export const ColumnDefinitions = {
  [eSearchBarColumns.FileNumber]: {
    name: eSearchBarColumns.FileNumber,
    header: <div className={'basis-36'}>File Number</div>,
    value: (order: ISearchOrderRequest) => <div className={'basis-36 self-center'}>{order.fileNumber}</div>,
  },
  [eSearchBarColumns.Buyer]: {
    name: eSearchBarColumns.Buyer,
    header: <div className={'basis-60'}>Buyer</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'basis-60 self-center'}>{getBorrowerStringFromParties(order.parties)}</div>
    ),
  },
  [eSearchBarColumns.Address]: {
    name: eSearchBarColumns.Address,
    header: <div className={'flex-grow basis-4/12'}>Address</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'flex-grow basis-4/12 self-center'}>{addressDataToString(order.propertyAddress)}</div>
    ),
  },
  [eSearchBarColumns.InternalStatus]: {
    name: eSearchBarColumns.InternalStatus,
    header: <div className={'basis-40'}>Status</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'basis-40 self-center'}>{prettyInternalOrderStatus[order.orderPhase]}</div>
    ),
  },
  [eSearchBarColumns.ClosingDate]: {
    name: eSearchBarColumns.ClosingDate,
    header: <div className={'basis-32'}>Closing Date</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'basis-32 self-center'}>{getDateString(DateFormat.short, order.closesOn)}</div>
    ),
  },
  [eSearchBarColumns.FeesLastEdited]: {
    name: eSearchBarColumns.FeesLastEdited,
    header: <div className={'basis-32'}>Fees Updated At</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'basis-32 self-center'}>
        <FeesUpdatedAt orderId={order.id} />
      </div>
    ),
  },
  [eSearchBarColumns.LastVisit]: {
    name: eSearchBarColumns.LastVisit,
    header: <div className={'basis-40'}>Last Visited</div>,
    value: (order: ISearchOrderRequest) => (
      <div className={'basis-40 self-center'}>
        <LastVisit fileNumber={`${order.fileNumber}`} />
      </div>
    ),
  },
};
